// extracted by mini-css-extract-plugin
export default {"container":"DishtypePreferencesSection-module__container__CLWr1"};